// Shared by the Rompslomp screens: a readable message for an API error (translated by error_key when we have one).
export function apiMessage(err, t, fallbackKey) {
    const key = err.response?.data?.error_key;
    const server = err.response?.data?.error;
    if (key) return t(key, { defaultValue: server || t(fallbackKey) });
    return server || t(fallbackKey);
}

export const euro = (cents) => ((cents || 0) / 100).toFixed(2);
